module.exports = __webpack_public_path__ + "static/media/SNX-USDT.08ea47be.svg";